var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"mr-2",attrs:{"x-small":"","outlined":"","color":_vm.getTypeColor(_vm.type)}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(" "+_vm._s(_vm.getTypeIcon(_vm.type))+" ")]),_vm._v(" "+_vm._s(_vm.getTypeText(_vm.type))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }